import React from 'react';

export default {
  svg: (
    <g>
      <g>
        <g>
          <circle fill="#FF7BAC" strokeWidth={0} cx={40} cy={40} r={38.5} />
          <path
            fill="#FFFFFF"
            strokeWidth={0}
            d="M40,2.5c20.711,0,37.5,16.789,37.5,37.5S60.711,77.5,40,77.5S2.5,60.711,2.5,40S19.289,2.5,40,2.5 M40,0.5 C18.22,0.5,0.5,18.22,0.5,40S18.22,79.5,40,79.5S79.5,61.78,79.5,40S61.78,0.5,40,0.5L40,0.5z"
          />
        </g>
        <g>
          <path
            fill="#FF7BAC"
            strokeWidth={0}
            d="M21.852,72.817c1.158-0.335,2.353-0.683,3.575-1.055l5.869-4.438h1.456v-5.123 c-1.099-0.779-2.16-1.689-3.131-2.694c-2.321-1.355-4.178-2.63-4.519-3.256c-0.203,0.634-0.751,1.004-1.441,1.231 c0.511-1.342,0.64-3.109,0-4.507l0.074,0.135c-0.351-1.041-0.61-2.124-0.77-3.239c-0.068-0.388-0.117-0.782-0.142-1.176 c-0.001-0.012,0-0.023-0.002-0.035c-0.582-0.56-0.946-1.342-0.946-2.213v-1.314c-0.021-0.064-0.042-0.123-0.062-0.188 c-1.693-5.418-2.309-14.987,1.502-22.123c0-0.006,0.006-0.006,0.006-0.012c2.814-5.252,8.023-10.424,16.963-10.424 c8.94,0,14.149,5.172,16.963,10.424c0,0.006,0.006,0.006,0.006,0.012c3.765,7.049,3.208,16.464,1.562,21.915v1.711 c0,0.93-0.421,1.752-1.073,2.316c-0.031,0.374-0.075,0.743-0.138,1.107c-0.16,1.115-0.419,2.198-0.764,3.239l0.068-0.135 c-0.64,1.398-0.511,3.165,0,4.507c-0.69-0.228-1.238-0.597-1.435-1.231c-0.33,0.605-2.06,1.807-4.253,3.101 c-0.041,0.043-0.083,0.084-0.123,0.126c-0.143,0.148-0.285,0.298-0.432,0.442c-0.094,0.093-0.192,0.181-0.288,0.272 c-0.15,0.142-0.3,0.286-0.453,0.423c-0.099,0.089-0.201,0.173-0.302,0.26c-0.154,0.133-0.307,0.267-0.464,0.396 c-0.105,0.086-0.212,0.167-0.319,0.25c-0.155,0.122-0.31,0.246-0.467,0.363c-0.11,0.082-0.222,0.159-0.333,0.239 c-0.136,0.098-0.271,0.199-0.409,0.293v4.907h1.348h0.005v0.004l5.841,4.417c1.169,0.357,2.313,0.691,3.424,1.012 C69.732,66.346,77.5,54.083,77.5,40C77.5,19.289,60.711,2.5,40,2.5S2.5,19.289,2.5,40C2.5,54.126,10.314,66.423,21.852,72.817z"
          />
          <path fill="none" d="M55.679,27.313h-0.043c0.018,0.037,0.031,0.068,0.043,0.105V27.313z" />
          <polygon
            fill="#E6E6E6"
            strokeWidth={0}
            points="47.53,68.074 47.53,70.031 48.981,67.324 47.633,67.324 47.633,68.109  "
          />
          <polygon
            fill="#E6E6E6"
            strokeWidth={0}
            points="48.986,67.324 48.981,67.324 48.986,67.328  "
          />
          <polygon
            fill="#E6E6E6"
            strokeWidth={0}
            points="32.753,67.324 31.297,67.324 32.753,70.041  "
          />
          <path
            fill="#000000"
            stroke="#000000"
            d="M55.715,50.478c-0.009,0.101-0.029,0.202-0.042,0.303c-0.026,0.214-0.05,0.429-0.089,0.642 c-0.023,0.126-0.057,0.25-0.084,0.375c-0.041,0.187-0.077,0.374-0.127,0.56c-0.036,0.133-0.082,0.264-0.123,0.397 c-0.053,0.176-0.103,0.353-0.164,0.527c-0.047,0.134-0.104,0.265-0.156,0.397c-0.066,0.171-0.128,0.343-0.202,0.512 c-0.055,0.127-0.119,0.251-0.178,0.377c-0.081,0.172-0.158,0.346-0.246,0.516c-0.061,0.119-0.131,0.235-0.195,0.354 c-0.095,0.173-0.187,0.347-0.289,0.518c-0.069,0.117-0.146,0.23-0.218,0.345c-0.106,0.169-0.209,0.338-0.321,0.504 c-0.077,0.114-0.16,0.224-0.24,0.336c-0.115,0.163-0.229,0.327-0.35,0.487c-0.083,0.11-0.172,0.216-0.258,0.324 c-0.125,0.158-0.249,0.318-0.379,0.473c-0.087,0.103-0.178,0.202-0.267,0.303c-0.135,0.155-0.269,0.311-0.409,0.461 c-0.051,0.055-0.105,0.109-0.157,0.163c2.193-1.294,3.923-2.496,4.253-3.101c0.197,0.634,0.745,1.004,1.435,1.231 c-0.511-1.342-0.64-3.109,0-4.507l-0.068,0.135c0.345-1.041,0.604-2.124,0.764-3.239c0.063-0.363,0.107-0.733,0.138-1.107 c-0.535,0.463-1.222,0.755-1.984,0.76C55.76,49.844,55.744,50.162,55.715,50.478z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M22.822,48.661c0.001,0.012,0,0.023,0.002,0.035c0.025,0.394,0.074,0.788,0.142,1.176c0.16,1.115,0.419,2.198,0.77,3.239 l-0.074-0.135c0.64,1.398,0.511,3.165,0,4.507c0.69-0.228,1.238-0.597,1.441-1.231c0.341,0.625,2.199,1.9,4.519,3.256 c-2.702-2.796-4.686-6.344-4.686-9.982C24.112,49.52,23.371,49.19,22.822,48.661z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M49.926,60.616c-0.099,0.089-0.201,0.173-0.302,0.26C49.725,60.789,49.827,60.705,49.926,60.616z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M50.667,59.921c-0.094,0.093-0.192,0.181-0.288,0.272C50.475,60.102,50.573,60.014,50.667,59.921z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M48.375,61.886c-0.11,0.082-0.222,0.159-0.333,0.239C48.153,62.045,48.264,61.968,48.375,61.886z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M49.16,61.272c-0.105,0.086-0.212,0.167-0.319,0.25C48.948,61.438,49.055,61.358,49.16,61.272z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M47.53,70.031v-1.957l-0.283-0.095l-14.392-3.646v-1.986c2.535,1.753,5.234,2.819,7.39,2.819 c0.032,0,0.067-0.005,0.1-0.006v-5.527c-3.06-0.001-5.54-2.206-5.54-4.926h0.863h4.677v-2.779h-3.694 c0,0,1.448-6.922,3.694-11.699c0,0,0-1.383,0-3.451c-0.019-0.01-0.04-0.018-0.06-0.027c-1.632-0.819-3.005-1.847-3.639-3.048 c-0.074,0.936,0.222,2.377,0.714,3.177c-3.497-0.548-5.788-3.091-7.124-6.428c-0.031-0.074-0.062-0.148-0.093-0.222 c-0.043,0.129-0.092,0.259-0.135,0.394c-0.893,2.58-2.081,6.662-3.731,9.673c-0.431,0.77-0.881,1.472-1.373,2.063l0.006,4.039 v2.703c-0.006,0-0.012,0.006-0.018,0.006c-0.653,0.265-1.392-0.376-2.069-1.644c-0.006,0-0.006-0.006-0.006-0.006 c-0.334-0.627-0.65-1.416-0.942-2.325v1.314c0,0.871,0.365,1.653,0.946,2.213c0.549,0.528,1.29,0.859,2.113,0.864 c0,3.638,1.983,7.185,4.686,9.982c0.971,1.005,2.032,1.915,3.131,2.694v5.123v2.717l3.914,7.304 C37.766,77.441,38.876,77.5,40,77.5c1.222,0,2.43-0.063,3.622-0.177L47.53,70.031z M30.834,41.559 c-0.047-1.342,1.003-2.468,2.345-2.515c1.342-0.047,2.468,1.003,2.515,2.345c0.005,0.142-0.009,0.279-0.027,0.415 c0.008,0.067,0.025,0.131,0.027,0.2c0.047,1.342-1.003,2.468-2.345,2.515c-1.342,0.047-2.468-1.003-2.515-2.345 c-0.005-0.142,0.009-0.279,0.027-0.415C30.854,41.692,30.836,41.627,30.834,41.559z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M53.603,56.301c0.072-0.115,0.149-0.229,0.218-0.345C53.751,56.072,53.675,56.186,53.603,56.301z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M54.109,55.438c0.065-0.118,0.134-0.234,0.195-0.354C54.243,55.203,54.174,55.32,54.109,55.438z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M53.041,57.141c0.08-0.112,0.163-0.223,0.24-0.336C53.204,56.919,53.121,57.029,53.041,57.141z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M54.551,54.568c0.059-0.126,0.123-0.25,0.178-0.377C54.674,54.318,54.609,54.442,54.551,54.568z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M55.25,52.755c0.041-0.132,0.087-0.264,0.123-0.397C55.337,52.491,55.291,52.622,55.25,52.755z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M55.673,50.781c0.012-0.101,0.032-0.202,0.042-0.303C55.706,50.579,55.686,50.68,55.673,50.781z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M54.931,53.679c0.052-0.133,0.109-0.264,0.156-0.397C55.039,53.415,54.982,53.547,54.931,53.679z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M55.5,51.798c0.027-0.125,0.062-0.25,0.084-0.375C55.562,51.549,55.527,51.673,55.5,51.798z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M52.434,57.952c0.086-0.108,0.174-0.214,0.258-0.324C52.608,57.738,52.52,57.844,52.434,57.952z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M51.099,59.479c0.041-0.042,0.083-0.084,0.123-0.126c0.052-0.055,0.106-0.108,0.157-0.163 C51.288,59.288,51.192,59.382,51.099,59.479z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M51.789,58.728c0.089-0.101,0.18-0.2,0.267-0.303C51.969,58.528,51.877,58.627,51.789,58.728z"
          />
          <path
            fill="#826AAE"
            strokeWidth={0}
            d="M25.428,71.762c-1.222,0.372-2.417,0.721-3.575,1.055c1.376,0.762,2.806,1.436,4.281,2.024l-1.308-2.624 L25.428,71.762z"
          />
          <path
            fill="#826AAE"
            strokeWidth={0}
            d="M55.452,72.217l-1.24,2.488c1.391-0.57,2.739-1.221,4.04-1.948c-1.111-0.321-2.255-0.656-3.424-1.012 L55.452,72.217z"
          />
          <path
            fill="#FFFFFF"
            strokeWidth={0}
            d="M32.753,70.041l-1.456-2.717l-5.869,4.438l-0.602,0.455l1.308,2.624c3.306,1.317,6.842,2.178,10.533,2.504 L32.753,70.041z"
          />
          <path
            fill="#FFFFFF"
            strokeWidth={0}
            d="M54.827,71.745l-5.841-4.417l-0.005-0.004l-1.451,2.707l-3.908,7.291c3.716-0.356,7.271-1.257,10.59-2.618 l1.24-2.488L54.827,71.745z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M51.099,59.479c-0.143,0.148-0.285,0.298-0.432,0.442 C50.814,59.777,50.956,59.628,51.099,59.479z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M48.842,61.522c-0.155,0.122-0.31,0.246-0.467,0.363 C48.532,61.768,48.687,61.645,48.842,61.522z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M50.379,60.193c-0.15,0.142-0.3,0.286-0.453,0.423 C50.08,60.479,50.229,60.335,50.379,60.193z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M49.624,60.876c-0.154,0.133-0.307,0.267-0.464,0.396 C49.317,61.143,49.47,61.009,49.624,60.876z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M47.53,67.324h0.103v-4.907c0.137-0.094,0.272-0.195,0.409-0.293 c-0.17,0.122-0.34,0.246-0.511,0.362V67.324z"
          />
          <polygon
            fill="#E6E6E6"
            strokeWidth={0}
            points="47.53,68.074 47.633,68.109 47.633,67.324 47.53,67.324  "
          />
          <polygon
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            points="47.53,68.074 47.633,68.109 47.633,67.324 47.53,67.324  "
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M54.729,54.191c0.073-0.169,0.136-0.341,0.202-0.512C54.865,53.85,54.802,54.022,54.729,54.191z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M54.729,54.191c0.073-0.169,0.136-0.341,0.202-0.512 C54.865,53.85,54.802,54.022,54.729,54.191z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M53.281,56.805c0.112-0.166,0.215-0.335,0.321-0.504C53.497,56.47,53.393,56.639,53.281,56.805z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M53.281,56.805c0.112-0.166,0.215-0.335,0.321-0.504 C53.497,56.47,53.393,56.639,53.281,56.805z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M53.821,55.956c0.102-0.171,0.194-0.345,0.289-0.518C54.015,55.611,53.922,55.785,53.821,55.956z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M53.821,55.956c0.102-0.171,0.194-0.345,0.289-0.518 C54.015,55.611,53.922,55.785,53.821,55.956z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M55.373,52.358c0.05-0.186,0.086-0.373,0.127-0.56C55.459,51.985,55.423,52.172,55.373,52.358z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M55.373,52.358c0.05-0.186,0.086-0.373,0.127-0.56 C55.459,51.985,55.423,52.172,55.373,52.358z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M54.305,55.084c0.088-0.17,0.165-0.344,0.246-0.516C54.47,54.741,54.392,54.914,54.305,55.084z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M54.305,55.084c0.088-0.17,0.165-0.344,0.246-0.516 C54.47,54.741,54.392,54.914,54.305,55.084z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M52.055,58.425c0.13-0.155,0.254-0.315,0.379-0.473C52.309,58.11,52.185,58.27,52.055,58.425z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M52.055,58.425c0.13-0.155,0.254-0.315,0.379-0.473 C52.309,58.11,52.185,58.27,52.055,58.425z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M55.086,53.282c0.062-0.174,0.111-0.351,0.164-0.527C55.197,52.931,55.148,53.107,55.086,53.282z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M55.086,53.282c0.062-0.174,0.111-0.351,0.164-0.527 C55.197,52.931,55.148,53.107,55.086,53.282z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M51.379,59.189c0.14-0.151,0.274-0.307,0.409-0.461C51.653,58.883,51.519,59.039,51.379,59.189z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M51.379,59.189c0.14-0.151,0.274-0.307,0.409-0.461 C51.653,58.883,51.519,59.039,51.379,59.189z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M55.715,50.478c0.03-0.316,0.045-0.634,0.045-0.952C55.76,49.844,55.744,50.162,55.715,50.478z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M55.715,50.478c0.03-0.316,0.045-0.634,0.045-0.952 C55.76,49.844,55.744,50.162,55.715,50.478z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M55.584,51.423c0.039-0.213,0.062-0.428,0.089-0.642C55.647,50.995,55.623,51.21,55.584,51.423z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M55.584,51.423c0.039-0.213,0.062-0.428,0.089-0.642 C55.647,50.995,55.623,51.21,55.584,51.423z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M52.692,57.628c0.121-0.16,0.234-0.324,0.35-0.487C52.926,57.304,52.812,57.469,52.692,57.628z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M52.692,57.628c0.121-0.16,0.234-0.324,0.35-0.487 C52.926,57.304,52.812,57.469,52.692,57.628z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M57.754,47.459c0,0,0,0.006-0.006,0.006c-0.677,1.268-1.416,1.909-2.069,1.644 c-0.006,0-0.012-0.006-0.019-0.006V46.4l0.006-3.497c-0.462-0.69-0.911-1.662-1.293-2.641v-0.006 c-0.745-1.878-1.256-3.787-1.256-3.787c-0.234,1.484-0.092,2.728,0.253,3.694c-2.247-0.64-3.183-1.49-4.71-3.313 c0,1.207,0.406,1.749,0.554,2.13c-1.744,0.159-5.767-0.65-8.869-2.202c0,2.068,0,3.451,0,3.451 c-2.246,4.776-3.694,11.699-3.694,11.699h3.694v2.779h4.558h0.984c0,2.72-2.481,4.926-5.542,4.926c0,0-0.001,0-0.001,0v5.527 c-0.033,0-0.068,0.006-0.1,0.006c-2.156,0-4.855-1.065-7.39-2.819v1.986l14.392,3.646l0.283,0.095v-0.75v-4.837 c0.172-0.116,0.341-0.24,0.511-0.362c0.111-0.08,0.223-0.157,0.333-0.239c0.157-0.117,0.312-0.241,0.467-0.363 c0.106-0.084,0.213-0.165,0.319-0.25c0.156-0.128,0.31-0.262,0.464-0.396c0.101-0.087,0.203-0.171,0.302-0.26 c0.154-0.138,0.303-0.281,0.453-0.423c0.096-0.091,0.194-0.179,0.288-0.272c0.147-0.144,0.289-0.294,0.432-0.442 c0.093-0.097,0.189-0.191,0.28-0.29c0.14-0.151,0.274-0.307,0.409-0.461c0.089-0.101,0.18-0.2,0.267-0.303 c0.13-0.155,0.254-0.315,0.379-0.473c0.085-0.108,0.174-0.214,0.258-0.324c0.121-0.16,0.234-0.324,0.35-0.487 c0.08-0.112,0.163-0.223,0.24-0.336c0.112-0.166,0.215-0.335,0.321-0.504c0.072-0.115,0.149-0.229,0.218-0.345 c0.102-0.171,0.194-0.345,0.289-0.518c0.065-0.118,0.134-0.234,0.195-0.354c0.088-0.17,0.165-0.344,0.246-0.516 c0.059-0.126,0.123-0.25,0.178-0.377c0.073-0.169,0.136-0.341,0.202-0.512c0.052-0.133,0.109-0.264,0.156-0.397 c0.062-0.174,0.111-0.351,0.164-0.527c0.041-0.132,0.087-0.264,0.123-0.397c0.05-0.186,0.086-0.373,0.127-0.56 c0.027-0.125,0.062-0.25,0.084-0.375c0.039-0.213,0.062-0.427,0.089-0.642c0.012-0.101,0.032-0.202,0.042-0.303 c0.03-0.316,0.045-0.634,0.045-0.952c0.762-0.005,1.449-0.297,1.984-0.76c0.652-0.564,1.073-1.387,1.073-2.316v-1.711 c-0.02,0.067-0.039,0.141-0.059,0.207C58.449,45.938,58.111,46.788,57.754,47.459z M44.996,42.174 c-0.005-0.142,0.009-0.279,0.027-0.415c-0.008-0.067-0.025-0.131-0.027-0.2c-0.047-1.342,1.003-2.468,2.345-2.515 s2.468,1.003,2.515,2.345c0.005,0.142-0.009,0.28-0.027,0.416c0.008,0.067,0.025,0.131,0.027,0.2 c0.047,1.342-1.003,2.468-2.345,2.515C46.168,44.566,45.042,43.516,44.996,42.174z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M57.754,47.459c0,0,0,0.006-0.006,0.006c-0.677,1.268-1.416,1.909-2.069,1.644 c-0.006,0-0.012-0.006-0.019-0.006V46.4l0.006-3.497c-0.462-0.69-0.911-1.662-1.293-2.641v-0.006 c-0.745-1.878-1.256-3.787-1.256-3.787c-0.234,1.484-0.092,2.728,0.253,3.694c-2.247-0.64-3.183-1.49-4.71-3.313 c0,1.207,0.406,1.749,0.554,2.13c-1.744,0.159-5.767-0.65-8.869-2.202c0,2.068,0,3.451,0,3.451 c-2.246,4.776-3.694,11.699-3.694,11.699h3.694v2.779h4.558h0.984c0,2.72-2.481,4.926-5.542,4.926c0,0-0.001,0-0.001,0v5.527 c-0.033,0-0.068,0.006-0.1,0.006c-2.156,0-4.855-1.065-7.39-2.819v1.986l14.392,3.646l0.283,0.095v-0.75v-4.837 c0.172-0.116,0.341-0.24,0.511-0.362c0.111-0.08,0.223-0.157,0.333-0.239c0.157-0.117,0.312-0.241,0.467-0.363 c0.106-0.084,0.213-0.165,0.319-0.25c0.156-0.128,0.31-0.262,0.464-0.396c0.101-0.087,0.203-0.171,0.302-0.26 c0.154-0.138,0.303-0.281,0.453-0.423c0.096-0.091,0.194-0.179,0.288-0.272c0.147-0.144,0.289-0.294,0.432-0.442 c0.093-0.097,0.189-0.191,0.28-0.29c0.14-0.151,0.274-0.307,0.409-0.461c0.089-0.101,0.18-0.2,0.267-0.303 c0.13-0.155,0.254-0.315,0.379-0.473c0.085-0.108,0.174-0.214,0.258-0.324c0.121-0.16,0.234-0.324,0.35-0.487 c0.08-0.112,0.163-0.223,0.24-0.336c0.112-0.166,0.215-0.335,0.321-0.504c0.072-0.115,0.149-0.229,0.218-0.345 c0.102-0.171,0.194-0.345,0.289-0.518c0.065-0.118,0.134-0.234,0.195-0.354c0.088-0.17,0.165-0.344,0.246-0.516 c0.059-0.126,0.123-0.25,0.178-0.377c0.073-0.169,0.136-0.341,0.202-0.512c0.052-0.133,0.109-0.264,0.156-0.397 c0.062-0.174,0.111-0.351,0.164-0.527c0.041-0.132,0.087-0.264,0.123-0.397c0.05-0.186,0.086-0.373,0.127-0.56 c0.027-0.125,0.062-0.25,0.084-0.375c0.039-0.213,0.062-0.427,0.089-0.642c0.012-0.101,0.032-0.202,0.042-0.303 c0.03-0.316,0.045-0.634,0.045-0.952c0.762-0.005,1.449-0.297,1.984-0.76c0.652-0.564,1.073-1.387,1.073-2.316v-1.711 c-0.02,0.067-0.039,0.141-0.059,0.207C58.449,45.938,58.111,46.788,57.754,47.459z M44.996,42.174 c-0.005-0.142,0.009-0.279,0.027-0.415c-0.008-0.067-0.025-0.131-0.027-0.2c-0.047-1.342,1.003-2.468,2.345-2.515 s2.468,1.003,2.515,2.345c0.005,0.142-0.009,0.28-0.027,0.416c0.008,0.067,0.025,0.131,0.027,0.2 c0.047,1.342-1.003,2.468-2.345,2.515C46.168,44.566,45.042,43.516,44.996,42.174z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M22.818,47.459c0,0,0,0.006,0.006,0.006c0.677,1.268,1.416,1.909,2.069,1.644c0.006,0,0.012-0.006,0.018-0.006V46.4 l-0.006-4.039c0.493-0.591,0.942-1.293,1.373-2.063c1.65-3.011,2.838-7.093,3.731-9.673c0.043-0.135,0.092-0.265,0.135-0.394 c0.031,0.074,0.062,0.148,0.093,0.222c1.336,3.337,3.626,5.88,7.124,6.428c-0.492-0.8-0.788-2.241-0.714-3.177 c0.634,1.201,2.007,2.229,3.639,3.048c0.019,0.01,0.04,0.018,0.06,0.027c3.102,1.551,7.125,2.361,8.869,2.202 c-0.148-0.382-0.554-0.924-0.554-2.13c1.527,1.823,2.463,2.672,4.71,3.313c-0.345-0.967-0.487-2.21-0.253-3.694 c0,0,0.511,1.909,1.256,3.787v0.006c0.382,0.979,0.831,1.952,1.293,2.641L55.66,46.4v2.703c0.006,0,0.012,0.006,0.019,0.006 c0.653,0.265,1.392-0.376,2.069-1.644c0.006,0,0.006-0.006,0.006-0.006c0.357-0.671,0.696-1.521,1.004-2.512 c0.021-0.066,0.039-0.14,0.059-0.207c1.646-5.451,2.203-14.866-1.562-21.915c0-0.006-0.006-0.006-0.006-0.012 c-2.814-5.252-8.023-10.424-16.963-10.424c-8.94,0-14.149,5.172-16.963,10.424c0,0.006-0.006,0.006-0.006,0.012 c-3.811,7.136-3.196,16.704-1.502,22.123c0.02,0.065,0.042,0.124,0.062,0.188C22.167,46.043,22.484,46.832,22.818,47.459z  M55.679,27.313v0.105c-0.012-0.037-0.025-0.068-0.043-0.105H55.679z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M33.349,44.52c1.342-0.047,2.392-1.173,2.345-2.515c-0.002-0.069-0.019-0.133-0.027-0.2 c-0.157,1.151-1.118,2.058-2.318,2.1c-1.273,0.044-2.34-0.902-2.488-2.145c-0.019,0.136-0.032,0.274-0.027,0.415 C30.881,43.516,32.007,44.566,33.349,44.52z"
          />
          <path
            fill="#F7CDB9"
            strokeWidth={0}
            d="M33.349,44.52c1.342-0.047,2.392-1.173,2.345-2.515c-0.002-0.069-0.019-0.133-0.027-0.2 c-0.157,1.151-1.118,2.058-2.318,2.1c-1.273,0.044-2.34-0.902-2.488-2.145c-0.019,0.136-0.032,0.274-0.027,0.415 C30.881,43.516,32.007,44.566,33.349,44.52z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M33.349,43.904c1.2-0.042,2.161-0.949,2.318-2.1c0.019-0.136,0.032-0.274,0.027-0.415 c-0.047-1.342-1.173-2.392-2.515-2.345c-1.342,0.047-2.392,1.173-2.345,2.515c0.002,0.069,0.019,0.133,0.027,0.2 C31.009,43.002,32.076,43.948,33.349,43.904z M34.111,41.323c-0.336,0.012-0.617-0.251-0.629-0.586 c-0.012-0.336,0.251-0.617,0.586-0.629c0.336-0.012,0.617,0.251,0.629,0.586C34.709,41.029,34.447,41.311,34.111,41.323z"
          />
          <path
            fill="#FFFFFF"
            strokeWidth={0}
            d="M34.069,40.107c-0.335,0.012-0.598,0.293-0.586,0.629c0.012,0.336,0.293,0.598,0.629,0.586 c0.335-0.012,0.598-0.293,0.586-0.629C34.686,40.358,34.404,40.096,34.069,40.107z"
          />
          <path
            fill="#F5D291"
            strokeWidth={0}
            d="M49.856,42.005c-0.002-0.069-0.019-0.133-0.027-0.2c-0.157,1.151-1.118,2.057-2.318,2.099 c-1.273,0.044-2.34-0.902-2.488-2.145c-0.019,0.136-0.032,0.274-0.027,0.415c0.047,1.342,1.173,2.392,2.515,2.345 C48.853,44.473,49.903,43.347,49.856,42.005z"
          />
          <path
            opacity={0.61}
            fill="#F4BD65"
            strokeWidth={0}
            d="M49.856,42.005c-0.002-0.069-0.019-0.133-0.027-0.2c-0.157,1.151-1.118,2.057-2.318,2.099 c-1.273,0.044-2.34-0.902-2.488-2.145c-0.019,0.136-0.032,0.274-0.027,0.415c0.047,1.342,1.173,2.392,2.515,2.345 C48.853,44.473,49.903,43.347,49.856,42.005z"
          />
          <path
            fill="#F7CDB9"
            strokeWidth={0}
            d="M49.856,42.005c-0.002-0.069-0.019-0.133-0.027-0.2c-0.157,1.151-1.118,2.057-2.318,2.099 c-1.273,0.044-2.34-0.902-2.488-2.145c-0.019,0.136-0.032,0.274-0.027,0.415c0.047,1.342,1.173,2.392,2.515,2.345 C48.853,44.473,49.903,43.347,49.856,42.005z"
          />
          <path
            fill="#000000"
            strokeWidth={0}
            d="M47.511,43.904c1.2-0.042,2.161-0.949,2.318-2.099c0.019-0.136,0.032-0.274,0.027-0.416 c-0.047-1.342-1.173-2.392-2.515-2.345s-2.392,1.173-2.345,2.515c0.002,0.069,0.02,0.133,0.027,0.2 C45.17,43.002,46.237,43.948,47.511,43.904z M48.273,41.323c-0.336,0.012-0.617-0.251-0.629-0.586 c-0.012-0.336,0.251-0.617,0.586-0.629c0.335-0.012,0.617,0.251,0.629,0.586C48.871,41.029,48.608,41.311,48.273,41.323z"
          />
          <path
            fill="#FFFFFF"
            strokeWidth={0}
            d="M48.23,40.107c-0.336,0.012-0.598,0.293-0.586,0.629c0.012,0.336,0.293,0.598,0.629,0.586 c0.335-0.012,0.598-0.293,0.586-0.629C48.847,40.358,48.566,40.096,48.23,40.107z"
          />
          <path
            fill="#F05D44"
            strokeWidth={0}
            d="M45.888,54.708h-0.984v1.231c0,0.34-0.276,0.616-0.616,0.616h-8.004c-0.34,0-0.616-0.276-0.616-0.616 v-1.231h-0.863c0,2.72,2.48,4.925,5.54,4.926c0,0,0.001,0,0.001,0C43.407,59.634,45.888,57.428,45.888,54.708z"
          />
          <path
            fill="#FFFFFF"
            strokeWidth={0}
            d="M36.284,56.555h8.004c0.34,0,0.616-0.276,0.616-0.616v-1.231h-4.558h-4.677v1.231 C35.668,56.279,35.944,56.555,36.284,56.555z"
          />
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 80 80'
};
